import { Component, OnInit, ViewChild } from '@angular/core'
import { Router } from '@angular/router'
import { NgForm } from '@angular/forms'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { UntypedFormBuilder, FormControl, UntypedFormGroup } from '@angular/forms'

import { SiteService } from '../../../../services/site.service'
import { MessageService } from '../../../../services/message.service'
import { TranslateService } from '@ngx-translate/core'
import { CustomerRequestsService } from '../../../../services/customer-requests.service'

import { EmailChangeViewModel } from '../../../../models/emailChangeViewModel'
import { ErrorMessageModalComponent } from '../../../modals/error-message-modal/error-message-modal.component'

@Component({
    selector: 'app-request-email-change-detail',
    templateUrl: './request-email-change-detail.component.html',
    styleUrls: ['./request-email-change-detail.component.scss'],
    standalone: false
})
export class RequestEmailChangeDetailComponent implements OnInit 
{
  @ViewChild('customForm') public customForm!: NgForm

  customFormGroup!: UntypedFormGroup
  formSubmitted: boolean = false
  isActiveLease: boolean = true

  emailPattern = "^[a-zA-Z0-9._%+\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,4}$"

  request =
  {
    emailAddress: ''
  }
  referenceNumber: string = ''
  emailChangeViewModel = new EmailChangeViewModel()

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private siteService: SiteService,
    private messageService: MessageService,
    private translateService: TranslateService,
    private formBuilder: UntypedFormBuilder,
    private customerRequestsService: CustomerRequestsService
  ) 
  { 
  }

  ngOnInit() 
  {
    this.retrieveEmailChangeViewModel()
  }

  retrieveEmailChangeViewModel()
  {
    this.messageService.startedHttpRequest('retrieveEmailChangeViewModel')
    this.customerRequestsService
      .getEmailChangeRequestViewModel()
			.subscribe({
				next: (apiResponse) =>
        {
          this.emailChangeViewModel = apiResponse

          if(this.emailChangeViewModel && this.emailChangeViewModel.isActiveLease)
          {
              this.request.emailAddress = this.emailChangeViewModel.emailAddress
          }
          else
          {
            this.isActiveLease = false
          }
        },
				error: (error) =>
				{
          this.isActiveLease = false
          this.messageService.completedHttpRequest('retrieveEmailChangeViewModel')
      
          const dialogConfig = new MatDialogConfig()
          dialogConfig.width = '500px',
          dialogConfig.data = {
            title: this.translateService.instant('COMMON_LBL_ERROR'),
            message: this.translateService.instant('COMMON_LBL_ERROR_MSG')
          }		
          this.dialog.open(ErrorMessageModalComponent, dialogConfig)		
				},
				complete: () =>
				{
					this.messageService.completedHttpRequest('retrieveEmailChangeViewModel')
				}
			})
  }

  submitForm(customerForm: NgForm)
  {
    this.formSubmitted = true

    if (customerForm.invalid)
    {
      return
    }

    if(this.request.emailAddress==this.emailChangeViewModel.emailAddress)
    {
        const dialogConfig = new MatDialogConfig()
        dialogConfig.width = '500px',
        dialogConfig.data = {
            title: '',
            message: this.translateService.instant('REQUEST_EMAIL_CHANGE_ERR_SAME_INFO'),
        }		
        this.dialog.open(ErrorMessageModalComponent, dialogConfig)

        return
    }

    const requestSummaryList: { key: string; value: string }[] = [
      { key: this.translateService.instant('REQUEST_EMAIL_CHANGE_CONFIRM_NAME'), value: this.siteService.customerAccount?.fullName ?? '' },
      { key: this.translateService.instant('REQUEST_EMAIL_CHANGE_CONFIRM_LEASENUM'), value: this.emailChangeViewModel.leaseNumber },
      { key: this.translateService.instant('REQUEST_EMAIL_CHANGE_CONFIRM_EMAIL'), value: this.request.emailAddress }
    ]

    return this.customerRequestsService.requestConfirmation(this.translateService.instant('REQUEST_EMAIL_CHANGE_CONFIRM_PRINT_TITLE'), requestSummaryList)
    .then((result) =>
    {
      if(result)
      {
        let changeRequest =
        {
          emailAddress: this.request.emailAddress
        }

        this.messageService.startedHttpRequest('submitForm')
        this.customerRequestsService
        .validateCustomerEmail(changeRequest)
        .subscribe({
          next: (apiResponse) =>
          {
            this.referenceNumber = apiResponse

            if ((this.referenceNumber != undefined) && (this.referenceNumber != ''))
            {
              this.siteService.viewParameters.requestEmailChangeValidation = {}
              this.siteService.viewParameters.requestEmailChangeValidation.referenceNumber = this.referenceNumber
              this.siteService.viewParameters.requestEmailChangeValidation.requestSummaryList = requestSummaryList
              
              this.router.navigate(['/email-validation'])      
            }	
                          
            this.formSubmitted = false
          },
          error: (error) =>
          {
            this.messageService.completedHttpRequest('submitForm')

            const dialogConfig = new MatDialogConfig()
            dialogConfig.width = '500px',
            dialogConfig.data = {
              title: this.translateService.instant('COMMON_LBL_ERROR'),
              message: this.translateService.instant('COMMON_LBL_ERROR_MSG'),
            }
            
            this.dialog.open(ErrorMessageModalComponent, dialogConfig)
          },
          complete: () =>
          {
            this.messageService.completedHttpRequest('submitForm')
          }
        })
      }
    })	
  }
}
